export default {
  filters: {
    /**
     * 舌裂纹
     * @param tongueCrackSign
     * @returns {string}
     * @constructor
     */
    TONGUE_CRACK_SIGN(tongueCrackSign) {
      switch (tongueCrackSign) {
        case "0":
          return "未检测到舌裂纹"
        case "1":
          return "检测到舌象"
        default:
          return ""
      }
    },
    /**
     * 舌胖瘦
     * @param tongueFatSign
     * @returns {string}
     * @constructor
     */
    TONGUE_FAT_SIGN(tongueFatSign) {
      switch (tongueFatSign) {
        case "0":
          return "正常"
        case "1":
          return "胖舌"
        default:
          return ""
      }
    },
    /**
     * 舌苔厚薄
     * @param tongueFatSign
     * @returns {string}
     * @constructor
     */
    TONGUE_COAT_THICK_SIGN(tongueFatSign) {
      switch (tongueFatSign) {
        case "0":
          return "薄"
        case "1":
          return "厚"
        default:
          return ""
      }
    },
    /**
     * 舌苔颜色
     * @param tongueCoatColorSign
     * @returns {string}
     * @constructor
     */
    TONGUE_COAT_COLOR_SIGN(tongueCoatColorSign) {
      switch (tongueCoatColorSign) {
        case "0":
          return "苔白"
        case "1":
          return "苔黄"
        default:
          return ""
      }
    },
    /**
     * 舌体颜色
     * @param tongueColorSign
     * @returns {string}
     * @constructor
     */
    TONGUE_COLOR_SIGN(tongueColorSign) {
      switch (tongueColorSign) {
        case "0":
          return "舌暗红"
        case "1":
          return "舌淡白"
        case "2":
          return "舌淡红"
        case "3":
          return "舌红"
        case "4":
          return "舌深红(舌紫)"
        default:
          return ""
      }
    },
    /**
     * 面色
     * @param sign
     * @returns {string}
     * @constructor
     */
    FACE_COLOR_SIGN(sign) {
      switch (sign) {
        case "0":
          return "面白"
        case "1":
          return "面黑"
        case "2":
          return "面红"
        case "3":
          return "面黄"
        case "4":
          return "面青"
        case "5":
          return "正常"
        default:
          return ""
      }
    },
    /**
     * 面部光泽
     * @param sign
     * @returns {string}
     * @constructor
     */
    FACE_LUSTRE_SIGN(sign) {
      switch (sign) {
        case "0":
          return "有光泽"
        case "1":
          return "少光泽"
        case "2":
          return "无光泽"
        default:
          return ""
      }
    },
    /**
     * 嘴唇颜色
     * @param sign
     * @returns {string}
     * @constructor
     */
    LIP_COLOR_SIGN(sign) {
      switch (sign) {
        case "0":
          return "淡白"
        case "1":
          return "淡红"
        case "2":
          return "红"
        case "3":
          return "深红"
        case "4":
          return "紫"
        default:
          return ""
      }
    },
    /**
     * 支付方式
     * @param payWay
     * @returns {string}
     * @constructor
     */
    PAY_WAY(payWay) {
      switch (payWay) {
        case "wechat":
          return "微信"
        case "aliPay":
          return "支付宝"
      }
    }
  }
}
